export default {
  createAssignmentUser: '/assignmentUser/createAssignmentUser',
  getSubmittedAssignmentsOfAnUser: '/assignmentUser/getSubmittedAssignmentsOfAnUser',
  assignmentAnalysis: '/assignmentUser/assignmentAnalysis',
  getSignedUrl: "/spaces/presigned_url"
}
